import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useShop } from '../context/ShopContext';
import { IoClose, IoAdd, IoRemove } from 'react-icons/io5';

const CartDrawer = () => {
  const {
    cart,
    isCartOpen,
    setIsCartOpen,
    updateQuantity,
    currency,
    cartTotal,
    setIsCheckoutOpen
  } = useShop();

  return (
    <AnimatePresence>
      {isCartOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.8 }}
            exit={{ opacity: 0 }}
            onClick={() => setIsCartOpen(false)}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              background: '#000000',
              zIndex: 2001,
              backdropFilter: 'blur(8px)'
            }}
          />

          <motion.div
            initial={{ x: '100%' }}
            animate={{ x: 0 }}
            exit={{ x: '100%' }}
            transition={{ type: 'spring', damping: 25, stiffness: 200 }}
            style={{
              position: 'fixed',
              top: 0,
              right: 0,
              width: '100%',
              maxWidth: '430px',
              height: '100vh',
              background: '#0a0a0a',
              borderLeft: '1px solid #222222',
              zIndex: 2002,
              padding: '32px',
              display: 'flex',
              flexDirection: 'column',
              boxShadow: '-20px 0 60px rgba(0, 0, 0, 0.9)'
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '28px' }}>
              <h2 style={{ fontSize: '1.4rem', color: '#ffffff', margin: 0, fontWeight: 900, textTransform: 'uppercase', letterSpacing: '-0.02em' }}>
                Cart Manifest
              </h2>
              <button onClick={() => setIsCartOpen(false)} style={{ color: '#888888' }}>
                <IoClose size={26} />
              </button>
            </div>

            <div style={{ flex: 1, overflowY: 'auto', paddingRight: '4px' }}>
              {cart.length === 0 ? (
                <div style={{ textAlign: 'center', marginTop: '5rem', color: '#666666' }}>
                  <div style={{ fontSize: '3rem', marginBottom: '16px' }}>—</div>
                  <h4 style={{ color: '#ffffff', marginBottom: '8px', fontWeight: 800 }}>Viewport Empty</h4>
                  <p style={{ fontSize: '0.88rem' }}>Browse our Cordyceps militaris collection.</p>
                </div>
              ) : (
                <ul style={{ listStyle: 'none', padding: 0 }}>
                  {cart.map(item => (
                    <li key={item.id} style={{
                      padding: '16px',
                      background: '#121212',
                      border: '1px solid #222222',
                      borderRadius: '8px',
                      marginBottom: '1rem',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '14px'
                    }}>
                      <div style={{
                        width: '60px',
                        height: '60px',
                        background: '#040404',
                        border: '1px solid #222222',
                        borderRadius: '6px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        overflow: 'hidden'
                      }}>
                        <img
                          src={item.image || "/media/whole.jpg"}
                          alt={item.title}
                          onError={(e) => { e.target.src = "/media/whole.jpg"; }}
                          style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '4px' }}
                        />
                      </div>

                      <div style={{ flex: 1 }}>
                        <h4 style={{ color: '#ffffff', marginBottom: '4px', fontSize: '0.88rem', lineHeight: 1.3, fontWeight: 700 }}>{item.title}</h4>
                        <p style={{ color: '#ffffff', fontSize: '0.9rem', fontWeight: 900, fontFamily: 'monospace' }}>
                          {currency.symbol}{(currency.code === 'INR' ? item.priceInr : item.priceUsd).toFixed(2)}
                        </p>
                      </div>

                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px', background: '#0a0a0a', padding: '4px 6px', borderRadius: '4px', border: '1px solid #222222' }}>
                        <button onClick={() => updateQuantity(item.id, 1)} style={{ color: '#ffffff' }}><IoAdd size={16} /></button>
                        <span style={{ color: '#ffffff', fontSize: '0.85rem', fontWeight: 800 }}>{item.quantity}</span>
                        <button onClick={() => updateQuantity(item.id, -1)} style={{ color: '#888888' }}><IoRemove size={16} /></button>
                      </div>
                    </li>
                  ))}
                </ul>
              )}
            </div>

            <div style={{ borderTop: '1px solid #222222', paddingTop: '20px', marginTop: '16px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px', color: '#ffffff', fontSize: '1.2rem', fontWeight: 900 }}>
                <span>Subtotal:</span>
                <span style={{ fontFamily: 'monospace' }}>{currency.symbol}{cartTotal.toFixed(2)}</span>
              </div>

              <button
                onClick={() => {
                  setIsCartOpen(false);
                  setIsCheckoutOpen(true);
                }}
                disabled={cart.length === 0}
                style={{
                  width: '100%',
                  padding: '16px',
                  background: cart.length === 0 ? '#1a1a1a' : '#ffffff',
                  color: cart.length === 0 ? '#666666' : '#000000',
                  fontWeight: 800,
                  borderRadius: '6px',
                  cursor: cart.length === 0 ? 'not-allowed' : 'pointer',
                  textTransform: 'uppercase',
                  border: 'none',
                  fontSize: '0.92rem',
                  letterSpacing: '0.08em',
                  transition: 'all 0.25s'
                }}
              >
                Proceed to Pre-order →
              </button>
              <p style={{ color: '#666666', fontSize: '0.72rem', textAlign: 'center', marginTop: '12px', marginBottom: 0, lineHeight: 1.5 }}>
                Pre-order only — dispatch begins once our FSSAI Central licence is issued.
              </p>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default CartDrawer;
